import { Collections } from "@diacare/common/models/collections";
import { Question } from "@diacare/common/models/question";
import {
  Button,
  Cell,
  DeleteButton,
  EditButton,
  GridRow,
  HeadCell,
  RouteTabs,
  SimpleModal,
  spacing,
  Tab,
  TabContent,
  TabContents,
  TabList,
  useModal,
} from "@litbase/alexandria";
import { ListCard } from "@litbase/alexandria/components/layout/list/list-card";
import { CustomListPage } from "@litbase/alexandria/components/layout/list/list-page";
import { litql } from "@litbase/core";
import { useQuery } from "@litbase/react";
import { Check, Plus, X } from "@styled-icons/boxicons-regular";
import { useParams } from "react-router-dom";
import styled from "styled-components";

export function QuestionListPage() {
  const { lang } = useParams();
  const [questions] = useQuery<Question>(Collections.QUESTIONS, {
    $live: true,
    $matchAll: {
      lang: lang,
    },
  });

  return (
    <>
      {/* @ts-ignore */}
      <CustomListPage title="Questions" addButtonLink="/questions/new" hideAddButtons>
        <RouteTabs routes={["/questions/hu", "/questions/en"]}>
          <TabList>
            <Tab>Hungarian</Tab>
            <Tab>English</Tab>
          </TabList>
          <TabContents>
            <TabContent>
              <Button to="/questions/edit/new?lang=hu">
                <Plus />
                Add a new question
              </Button>
              <QuestionList items={questions} />
            </TabContent>
            <TabContent>
              <Button to="/questions/edit/new?lang=en">
                <Plus />
                Add a new question
              </Button>
              <QuestionList items={questions} />
            </TabContent>
          </TabContents>
        </RouteTabs>
      </CustomListPage>
    </>
  );
}

function QuestionList({ items }: { items: Question[] }) {
  const { showModal, dismissModal } = useModal();
  return (
    // @ts-expect-error
    <ListCard
      columns="repeat(4, 1fr)"
      items={items}
      headerRowComponent={
        <GridRow>
          <HeadCell>Created at</HeadCell>
          <HeadCell>Title</HeadCell>
          <HeadCell>Answered</HeadCell>
          <HeadCell></HeadCell>
        </GridRow>
      }
      rowComponent={(item: Question) => (
        <GridRow>
          <Cell>{item.createdAt?.toLocaleString()}</Cell>
          <Cell>{item.title}</Cell>
          <Cell>{item.answer ? <Check /> : <X />}</Cell>
          <Cell>
            <EditButton to={`/questions/edit/` + item._id.toUrlSafeString()} />
            <DeleteButton
              onClick={() =>
                showModal(
                  <SimpleModal>
                    <span>Biztos törölni akarod a kérdést?</span>
                    <Row>
                      <Button onClick={() => dismissModal()}>Mégse</Button>
                      <Button
                        $kind="danger"
                        onClick={() => {
                          litql.query(Collections.QUESTIONS, { $match: { _id: item._id }, $pull: 1 });
                          dismissModal();
                        }}
                      >
                        Igen
                      </Button>
                    </Row>
                  </SimpleModal>,
                )
              }
            />
          </Cell>
        </GridRow>
      )}
    />
  );
}

const Row = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${spacing._6};
  > * + * {
    margin-left: ${spacing._4};
  }
`;
